/**
 * Convert stored lastSeen values to Unix milliseconds.
 * Matches UI logic in `web-app/components/dates/utils/freshnessCalculation.ts`:
 * numeric values below 10_000_000_000 are treated as **seconds** (common in Unix APIs);
 * JavaScript's `new Date(n)` always treats numbers as **milliseconds**, which would
 * mis-read second-based timestamps as ~1970 and make jobs look ancient.
 */
const SECONDS_VS_MS_THRESHOLD = 10_000_000_000;

export function parseLastSeenToUnixMs(lastSeen: unknown): number | undefined {
  if (lastSeen === undefined || lastSeen === null) return undefined;
  if (typeof lastSeen === 'number' && Number.isFinite(lastSeen)) {
    return lastSeen < SECONDS_VS_MS_THRESHOLD ? lastSeen * 1000 : lastSeen;
  }
  const raw = String(lastSeen).trim();
  if (!raw) return undefined;
  if (/^\d+$/.test(raw)) {
    const numeric = Number(raw);
    if (!Number.isFinite(numeric)) return undefined;
    return numeric < SECONDS_VS_MS_THRESHOLD ? numeric * 1000 : numeric;
  }
  const parsed = new Date(raw);
  const t = parsed.getTime();
  return Number.isNaN(t) ? undefined : t;
}
